import { get } from 'svelte/store';

import { PhoneCell, userID } from '../store';

import { getLoginData } from './passport';

type AnyValueObject = {
    [key: string]: any;
};

export const mediaEventUp = async (sceneId: number, data: AnyValueObject) => {
    try {
        let mobile = get(PhoneCell);
        let uid = get(userID);

        if (!uid || !mobile) {
            const loginData = await getLoginData();

            mobile = loginData?.cell ?? '';
            uid = loginData?.uid ?? '';
        }

        window.adv?.mediaEventUp(sceneId, {
            data: {
                uid: uid,
                callingCode: '52',
                mobile: mobile,
                biz_extra_data: {
                    countryCode: 'MX',
                    businessId: '104',
                    businessScene: 'external_landing_page'
                },
                ...data
            }
        });
    } catch (error) {
        console.error(error);
    }
};

// 使用闭包跟踪执行状态
const createOnceTracker = () => {
    const executed = new Set<number>();

    return (eventId: number): boolean => {
        if (executed.has(eventId)) {
            return false;
        }

        executed.add(eventId);

        return true;
    };
};

// 跟踪器实例
const trackOnce = createOnceTracker();

export const sendEventOnce = async (scene: number, ext?: any) => {
    // 如果已执行过则直接返回
    if (!trackOnce(scene)) {
        return;
    }

    // 执行原始埋点
    return mediaEventUp(scene, ext);
};
